import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import {Button, CrossIcon, Heading, Text, TickIcon} from '@edume/magnificent';

import styles from './styles.module.scss';

function ChangeStoreList({
  onClose,
  stores,
  selectedStoreId,
  selectStore,
  teamName,
}) {
  const selectedStoreName = stores.find(
    (store) => store.id === selectedStoreId
  )?.name;

  return (
    <div styleName='change-store'>
      <div styleName='change-store-header'>
        <div styleName='change-store-header-inner'>
          <Heading
            as='h1'
            colour='white'
            size='hamster'
            textTransform='none'
            weight='semiBold'
          >
            Change Store
          </Heading>
          <button styleName='change-store-close' onClick={onClose}>
            <CrossIcon size='big' colour='white' />
          </button>
        </div>
      </div>
      {(!!selectedStoreId || !!teamName) && (
        <div styleName='change-store-bar'>
          <div>
            <Text
              colour='textSecondary'
              inline='false'
              lineHeight='tight'
              size='l'
              textTransform='none'
              weight='regular'
            >
              Current selection
            </Text>
            <Heading
              as='h2'
              colour='textPrimary'
              size='sheep'
              textTransform='none'
              weight='semiBold'
            >
              {selectedStoreName || teamName}
            </Heading>
          </div>
          {selectedStoreName && (
            <Button
              buttonText='Button action'
              innerContent='text'
              isCursorAllowed
              reskinClassName=''
              type='thirdary'
              onClick={() => {
                selectStore(null);
                onClose();
              }}
            >
              Reset
            </Button>
          )}
        </div>
      )}
      <ul styleName='change-store-list'>
        {stores
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((store, index) => (
            <li key={index}>
              <div
                onClick={() => {
                  selectStore(store.id);
                  onClose();
                }}
                role='button'
                onKeyDown={(e) => {
                  if (e.key.toLocaleLowerCase() === 'enter') {
                    selectStore(store.id);
                    onClose();
                  }
                }}
                tabIndex={0}
              >
                <Text
                  colour='textPrimary'
                  inline='false'
                  lineHeight='tight'
                  size='xl'
                  textTransform='none'
                  weight='medium'
                >
                  {store.name}
                </Text>
                {selectedStoreId === store.id && <TickIcon colour='aqua700' />}
              </div>
            </li>
          ))}
      </ul>
    </div>
  );
}

ChangeStoreList.propTypes = {
  teamName: PropTypes.string,
  onClose: PropTypes.func,
  selectStore: PropTypes.func,
  stores: PropTypes.array,
  selectedStoreId: PropTypes.number,
};

export default CSSModules(ChangeStoreList, styles, {allowMultiple: true});
